import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarBlank } from "@phosphor-icons/react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function DatePicker({ value, onChange, className = "", testId }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`flex h-10 w-full items-center justify-between rounded-md border px-3 text-sm ${className}`} data-testid={testId}>
          <span className={date ? "" : "text-slate-400"}>{date ? format(date, "MMM d, yyyy") : "Pick a date"}</span>
          <CalendarBlank size={16} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white" align="start">
        <Calendar mode="single" selected={date} defaultMonth={date} initialFocus
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
